import { configureStore } from "@reduxjs/toolkit";
import themeReducer from "../GlobalSlice/theme.slice";
import agentReducer from "../modules/OnboardingDetails/agent.slice";
import sideBarReducer from "../Components/SideBar/sidebar.slice";
import datepickerReducer from "../app/datePickerSlice";
import brokerReducer from "../GlobalSlice/broker.slice";
import userReducer from "../GlobalSlice/userSlice";
import authReducer from "../GlobalSlice/auth.slice";
export const store = configureStore({
  reducer: {
    theme: themeReducer,
    agent: agentReducer,
    sideBar: sideBarReducer,
    datepicker: datepickerReducer,
    broker: brokerReducer,
    user: userReducer,
    auth: authReducer,
  },
  devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
